<template>
  <div class="side-phone-con">
    <div class="card-con" :style="nowCardBg">
      <div class="card-top">
        <div class="card-logo">
          <img :src="logoUrl" alt="">
        </div>
        <div class="card-center">
          <span class="card-title">{{title | setTitle}}</span>
          <span class="card-des">{{store | setStore}}</span>
        </div>
        <div class="er-code"></div>
      </div>
    </div>
    <div class="card-main">
      <div>
        <span>积分</span>
        <span>0</span>
      </div>
      <div>
        <span>等级</span>
        <span>查看</span>
      </div>
      <div>
        <span>优惠券</span>
        <span>查看</span>
      </div>
    </div>
    <div class="card-list">
      <div>立即使用</div>
      <div>会员卡详情</div>
      <div>公众号</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    store: {
      type: String,
    },
    logoUrl: {
      type: String,
    },
    nowCardBg: {
      type: String
    },
  },
  filters: {
    setTitle: function(val) {
      if (val == "") {
        return "会员卡标题";
      } else {
        return val;
      }
    },
    setStore: function(val) {
      if (val == "") {
        return "商品名称";
      } else {
        return val;
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.side-phone-con{
  width: 100%;
  height: auto;
  background: #fff;
  .card-con {
    width: 96%;
    height: 180px;
    margin: 20px auto;
    padding-top: 10px;
    background: #fff;
    display: flex;
    border-radius: 12px;
    .card-top {
      width: 100%;
      height: 60px;
      display: flex;
      padding: 10px 20px;
      align-items: center;
      .card-logo {
        width: 50px;
        height: 50px;
        background: #f2f2f2;
        border-radius: 25px;
        img {
          width: 100%;;
          height: 100%;
          border-radius: 50%;
          overflow: hidden;
        }
      }
      .card-center {
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        color: #fff;
        .card-title {
          font-size: 16px;
        }
        .card-des {
          font-size: 12px;
        }
      }
    }
  }
  .card-main {
    width: 100%;
    height: 50px;
    display: flex;
    padding: 0 10px;
    div {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      span:nth-child(2) {
        color: #409EFF;
      }
    }
  }
  .card-list {
    width: 100%;
    margin-top: 30px;
    display: flex;
    padding: 0 10px;
    flex-direction: column;
    div:nth-child(1) {
      border-top: 1px solid #f1f1f1;
    }
    div {
      color: #363636;
      width: 100%;
      height: 50px;
      line-height: 50px;
      border-bottom: 1px solid #f1f1f1;
    }
  }
}
</style>